/* eslint-disable */
import convertList from '../convertList';
import filters from '../filters';
import  { envDomain } from '@/common/contact-selector/utils/domainConfig'
// 加载临界值，小于该数字直接加载详情
const LOAD_DETAIL_NUM = 100;

export default function(config) {
    const moreConfig = {
        totalState: false
    };
    const selfConfig = config.extendConfig ;

    return new Promise((resolve, reject) => {
        _getCompanyWeChatOrg({depId:config.groupId})
            .then(res => {
                let {users, deps} = res.data
                let list = [];
                list = deps.map(x => {
                    const obj = x;
                    return {
                        id: x.id,
                        name: x.name,
                        list:[],
                        // type: "group",
                        loaded: false
                    }
                });
                list = [...list, ...users.map(x => {
                    const obj = x;
                    obj.face = x.avatar
                    obj.id = x.userid
                    return obj
                })];


                config = Object.assign(config, moreConfig);
                const newList = convertList(list, {
                    list: 'list',
                    groupName: 'name'
                }, config,
                   config.nodeId); // 对于组织架构这个种多层级的这个config.nodeId参数是必须的，注意坑

                resolve({list:newList});
            })
            .catch(err => {
                reject(err);
            });
    });

}


function _getCompanyWeChatOrg(params) {
    return Vue.prototype.$_sAjax.crossGet(`${envDomain.gateway}/v1/wework/DepTreeNode`,{ params});
}
